var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_10479)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.283 160.705C215.099 161.251 197.404 199.803 192.686 219.148C189.834 254.074 222.249 261.928 229.751 256.925C233.945 254.129 242.484 250.418 248.639 249.156C254.794 250.418 263.334 254.129 267.528 256.925C275.03 261.928 307.445 254.074 304.593 219.148C299.875 199.803 282.18 161.251 248.996 160.705V160.699C248.877 160.699 248.758 160.7 248.639 160.701C248.521 160.7 248.402 160.699 248.283 160.699V160.705Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.176 285.054L146.861 560H353.595L333.131 269.313C357.478 228.596 356.218 176.79 352.545 155.977C345.829 117.358 324.911 117.498 315.291 122.396C314.452 92.1725 303.746 87.2402 287.482 82.5179C263.868 79.3696 251.625 94.2362 247.078 104.031C247.078 93.0119 237.108 83.9732 229.762 82.5179C185.267 73.7029 177.294 105.43 176.769 122.396C167.954 117.778 154.05 122.815 147.384 128.692C107.506 163.847 141.614 259.868 164.176 285.054Z",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.273,
    cy: 160.699,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.487,
    cy: 160.699,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.496,
    cy: 119.772,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.61,
    cy: 119.772,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.53 471.38C177.842 452.581 157.286 463.547 149.844 471.38L142 572H269.921C278.128 518.978 260.066 505.723 250.009 505.723C236.01 503.795 211.19 482.024 200.53 471.38Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.686 339.441C217.216 296.629 182.134 281.309 163.527 279L156 390.438C158.509 400.511 171.262 394.635 177.325 390.438C200.908 381.875 208.059 352.872 208.686 339.441Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.372 351.706C288.181 335.939 304.254 345.136 310.815 351.706C329.02 358.315 330.496 381.885 325.576 389.892C304.664 408.985 308.559 423.151 304.664 436.085C292.363 464.416 283.752 470.575 276.372 469.959C270.467 469.467 255.05 447.171 248.079 436.085C225.323 397.283 251.77 380.037 257.92 376.342C262.841 373.386 272.271 358.686 276.372 351.706Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.776 476.889L417.252 417.364",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 359.215,
    cy: 326.588,
    r: 107.084,
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.199 227.579L361.689 274.439C361.98 275.45 362.784 276.228 363.79 276.537C387.692 283.866 401.676 308.874 395.153 333.218C388.641 357.524 364.093 372.181 339.766 366.65C338.679 366.403 337.53 366.727 336.774 367.547L300.018 407.395",
    stroke: "black",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.383 251.05C363.494 258.57 365.372 275.941 379.992 285.264C387.165 289.314 399.646 303.82 392.178 329.448C389.517 341.248 377.304 364.504 349.744 363.126C344.167 362.847 333.96 368.373 329.391 381.642L327.969 386.948C328.343 385.057 328.823 383.29 329.391 381.642L364.383 251.05Z",
    fill: "url(#paint0_linear_226_10479)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 362.129,
    cy: 334.822,
    rx: 8.58928,
    ry: 6.1394,
    transform: "rotate(121.484 362.129 334.822)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.418 108.755L138.869 125.365C139.212 126.645 140.683 127.244 141.822 126.567L152.279 120.356C153.529 119.614 153.595 117.828 152.402 116.996L137.494 106.597C135.964 105.529 133.935 106.953 134.418 108.755Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.298 109.015L344.056 125.021C343.861 126.414 342.327 127.176 341.099 126.489L330.712 120.683C329.476 119.992 329.33 118.271 330.431 117.382L343.061 107.182C344.472 106.042 346.55 107.219 346.298 109.015Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.301 65.4317L300.852 81.5845C300.9 82.9901 299.52 84.0048 298.193 83.5405L286.96 79.6123C285.623 79.1449 285.182 77.4747 286.114 76.4084L296.796 64.1838C297.99 62.8178 300.239 63.6187 300.301 65.4317Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.655 61.7614L202.94 77.2205C202.529 78.5657 203.599 79.9031 205.002 79.7985L216.868 78.9135C218.28 78.8082 219.139 77.3091 218.515 76.038L211.364 61.4639C210.564 59.8354 208.184 60.0264 207.655 61.7614Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_226_10479",
    x1: 391.97,
    y1: 330.331,
    x2: 346.32,
    y2: 318.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#282828",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_10479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/피부과_피부 종양.90c9524709dc4410cfcaa37fd6de115c.svg";
export { ForwardRef as ReactComponent };